var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9417 4.20097L11.5527 0.797554C11.1891 0.432468 10.6963 0.225586 10.1833 0.225586H1.93891C0.868471 0.229642 0 1.10179 0 2.17677V19.0519C0 20.1268 0.868471 20.999 1.93891 20.999H13.5724C14.6428 20.999 15.5113 20.1268 15.5113 19.0519V5.58018C15.5113 5.06501 15.3053 4.56606 14.9417 4.20097ZM13.4148 5.42198H10.3409V2.33497L13.4148 5.42198ZM1.93891 19.0519V2.17677H8.40195V6.39555C8.40195 6.93506 8.83416 7.36911 9.3714 7.36911H13.5724V19.0519H1.93891Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46346 10.5274V11.3561H6.01186V12.0771H5.46346V13.6021C5.46346 13.7274 5.48605 13.8147 5.53124 13.864C5.57642 13.9133 5.66577 13.9379 5.79928 13.9379C5.90197 13.9379 5.98824 13.9318 6.05807 13.9195V14.662C5.87116 14.7215 5.67604 14.7513 5.4727 14.7513C5.11532 14.7513 4.85139 14.6671 4.68091 14.4987C4.51043 14.3302 4.4252 14.0745 4.4252 13.7315V12.0771H4.00003V11.3561H4.4252V10.5274H5.46346Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77413 12.2743L8.25783 11.3561H9.33615L8.45809 12.9798L9.37928 14.6897H8.2948L7.77105 13.7038L7.25654 14.6897H6.1659L7.09017 12.9798L6.2152 11.3561H7.30583L7.77413 12.2743Z",
    fill: "#95AAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8797 10.5274V11.3561H11.4281V12.0771H10.8797V13.6021C10.8797 13.7274 10.9023 13.8147 10.9475 13.864C10.9926 13.9133 11.082 13.9379 11.2155 13.9379C11.3182 13.9379 11.4045 13.9318 11.4743 13.9195V14.662C11.2874 14.7215 11.0923 14.7513 10.8889 14.7513C10.5315 14.7513 10.2676 14.6671 10.0971 14.4987C9.92665 14.3302 9.84141 14.0745 9.84141 13.7315V12.0771H9.41625V11.3561H9.84141V10.5274H10.8797Z",
    fill: "#95AAC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5113,
    height: 20.7694,
    fill: "white",
    transform: "translate(0 0.230469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.06e4d911f4254e8dada338664e4cf696.svg";
export { ForwardRef as ReactComponent };